import Box from "@material-ui/core/Box";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
export const getMasterColumns = (editEncrypt, deleteEncrypt) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      //sort: true,

      // events: onClickCol,
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <EditIcon
              color="action"
              onClick={() => {
                editEncrypt(row);
              }}
            />
            <DeleteIcon
             color="action"
              onClick={() => {
                deleteEncrypt(row.ENCRYPT_ID);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "ENCRYPT_ID",
      text: "Encrypt Map ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ENCRYPT_NAME",
      text: "Encrypt Map Name",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "ENCRYPT_TYPE_NAME",
      text: "Encrypt Type",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ACTIVE",
      text: "Active",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
  ];
  return columns;
};
